import { PaymentModuleId } from '@foundation/apis/payments';
import { SupportedLanguage } from '@foundation/localization';

import { registerStartupable } from '@/services/base/StartupHelper';

import { getRazorPayRedirectUrl } from './RazorPayApi';
import { OptionalStartupable } from '../base/Startupable';
import PaymentStore from '../payments/PaymentStore';

class RazorPayService implements OptionalStartupable {
  public readonly name = 'RazorPayService';
  public readonly moduleId = PaymentModuleId.RazorPay;

  constructor() {
    registerStartupable(this, [PaymentStore]);
  }
  shouldStart(): boolean {
    return PaymentStore.allowedPaymentModules.includes(this.moduleId);
  }

  public startup(): Promise<void> {
    return Promise.resolve();
  }

  public getRedirectUrl(
    locale: SupportedLanguage,
    accessToken: string,
    telemetryConsent = false,
  ): Promise<string> {
    const paymentIntentId = PaymentStore.paymentIntentId;

    return getRazorPayRedirectUrl(
      paymentIntentId,
      accessToken,
      locale,
      telemetryConsent,
    );
  }
}

export default new RazorPayService();
